<template>
    <div class="occupation-view">
        <div class="occupation-details">
            <MaterialSlideShow
                class="slide_fixed_height"
                :smallNavigation="true"
                :slides="occupationImages"
                imageKey="url"
            >
            </MaterialSlideShow>
            <div class="text-content pt-3">
                <div class="occupation-detail-header">
                    <div class="occupation-info">
                        <p class="cemetery-name">{{ cemeteryName }}</p>
                        <div class="wrapper row flex-column no-gutters">
                            <div class="col-12">
                                <div class="row no-gutters">
                                    <div class="col-sm d-flex">
                                        <div class="occupation-status-id">
                                            <h3 class="occupation-id">
                                        		<div class="main-title">
                                                    <span>{{ occupationCode }}</span>
                                                </div>
                                                <span
                                                    v-if="occupationState"
                                                    class="occupation-status vacant"
                                                >
                                                    {{ occupationState }}
                                                </span>
                                            </h3>
                                        </div>
                                    </div>
                                    <div
                                        class="col-auto"
                                        v-if="allowViewDetail"
                                    >
                                        <button
                                            type="button"
                                            class="occupation-view-btn btn btn-outline-secondary-main"
                                            :aria-label="`view ${occupationName}`"
                                            @click.prevent="onViewDetailOccupation"
                                        >
                                            <span>
                                                <!-- <i class="fas fa-pencil view-icon" ></i> -->
                                                <i class="far fa-rectangle-list view-icon"></i>
                                                <p class="text-icon">{{ $t(`${baseTranslateID}.buttons.view`) }}</p>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="occupation-interments-info">
                                    <div class="amounts-direction">
                                        <div
                                            class="total-capacity item-with-separator"
                                            v-if="totalCapacityText"
                                        >
                                            <!-- <img loading="lazy" src="https://demo.chronicle.rip/assets/images/person_icon_grey.svg" alt="Image description for person_icon_grey" class="icon"> -->
                                            <svg
                                                class="icon"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="14"
                                                height="15"
                                                viewBox="0 0 14 15"
                                                fill="none"
                                            >
                                                <path
                                                    d="M10.2876 4.11067C10.657 6.33744 8.73615 8.26726 6.44594 7.97036C5.04226 7.74769 3.93409 6.63434 3.71246 5.22405C3.34307 2.99729 5.26389 1.06737 7.48023 1.36427C8.95779 1.51272 10.1398 2.70039 10.2876 4.11067Z"
                                                    stroke="currentColor"
                                                    stroke-opacity="0.6"
                                                    stroke-width="1.5"
                                                    stroke-miterlimit="10"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M1 13.334V11.6673C1 11.4673 1.07059 11.2673 1.28235 11.134C1.91765 10.6006 3.89412 9.33398 7 9.33398C10.1059 9.33398 12.0824 10.6006 12.7176 11.134C12.8588 11.2673 13 11.4673 13 11.6673V13.334C13 13.734 12.7176 14.0007 12.2941 14.0007H1.70588C1.28235 14.0007 1 13.734 1 13.334Z"
                                                    stroke="currentColor"
                                                    stroke-opacity="0.6"
                                                    stroke-width="1.5"
                                                    stroke-miterlimit="10"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </svg>
                                            <span class="amount"> {{ totalCapacityText }} </span>
                                            <div class="separator"></div>
                                        </div>

                                        <div
                                            class="burial-capacity item-with-separator"
                                            v-if="burialsCapacityText"
                                        >
                                            <!-- <img loading="lazy" src="https://demo.chronicle.rip/assets/images/casket_interment_grey.svg" alt="Image description for casket_interment_grey" class="icon"> -->
                                            <svg
                                                class="icon"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                            >
                                                <path
                                                    d="M6.06602 15.0003H9.66602C9.99935 15.0003 10.266 14.8003 10.3327 14.4669L11.9993 5.86693C12.1327 5.26693 12.066 4.66693 11.7993 4.13359L10.3993 1.33359C10.266 1.13359 10.066 0.933594 9.79935 0.933594H5.93268C5.66602 1.00026 5.46602 1.13359 5.33268 1.40026L3.93268 4.20026C3.66602 4.73359 3.59935 5.33359 3.73268 5.86693L5.46602 14.4669C5.46602 14.8003 5.79935 15.0003 6.06602 15.0003Z"
                                                    stroke="currentColor"
                                                    stroke-opacity="0.6"
                                                    stroke-width="1.5"
                                                    stroke-miterlimit="10"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M8 4.33398V7.66732M9 5.66732H7"
                                                    stroke="currentColor"
                                                    stroke-opacity="0.6"
                                                    stroke-width="1.5"
                                                    stroke-miterlimit="10"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </svg>
                                            <span class="amount"> {{ burialsCapacityText }} </span>
                                            <div class="separator"></div>
                                        </div>

                                        <div
                                            class="cremation-capacity item-with-separator"
                                            v-if="cremationCapacityText"
                                        >
                                            <!-- <img loading="lazy" src="https://demo.chronicle.rip/assets/images/cremation_urn.svg" alt="Image description for cremation_urn" class="icon"> -->
                                            <svg
                                                class="icon"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                            >
                                                <path
                                                    d="M8 1V1.66667M8 1.66667C6.33333 1.66667 5.66667 2.66667 5.66667 2.66667V4.66667M8 1.66667C9.66667 1.66667 10.3333 2.66667 10.3333 2.66667V4.66667M5.66667 4.66667H10.3333M5.66667 4.66667C5.66667 4.66667 3 5 3 8C3 10.5333 5 13.1333 5.53333 13.8C5.6 13.9333 5.66667 14.0667 5.66667 14.2V14.9333H10.3333V14.2C10.3333 14.0667 10.4 13.9333 10.4667 13.8C11.0667 13.1333 13 10.6 13 8C13 5 10.3333 4.66667 10.3333 4.66667"
                                                    stroke="currentColor"
                                                    stroke-opacity="0.6"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </svg>
                                            <span class="amount"> {{ cremationCapacityText }} </span>
                                            <div class="separator"></div>
                                        </div>

                                        <div
                                            class="entombment-capacity item-with-separator"
                                            v-if="entombmentCapacityText"
                                        >
                                            <!-- <img loading="lazy" src="https://demo.chronicle.rip/assets/images/entombment_urn.svg" alt="Image description for entombment_urn" class="icon"> -->
                                            <svg
                                                class="icon"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                            >
                                                <path
                                                    d="M1.30469 14H3.42602M14.6933 14H12.5372M3.42602 14V6.45312H1.30469L7.98157 2L14.6933 6.45312H12.5372V14M3.42602 14H6.41049M12.5372 14H9.5266M6.41049 14V8.50609C6.41049 8.50609 6.41049 6.97821 7.98157 6.97821C9.55264 6.97821 9.5266 8.50609 9.5266 8.50609V14M6.41049 14H7.96854H9.5266"
                                                    stroke="currentColor"
                                                    stroke-opacity="0.6"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </svg>
                                            <span class="amount"> {{ entombmentCapacityText }} </span>
                                            <div class="separator"></div>
                                        </div>

                                        <div
                                            class="memorial-capacity item-with-separator"
                                            v-if="memorialCapacityText"
                                        >
                                            <img
                                                loading="lazy"
                                                src="https://demo.chronicle.rip/assets/images/memorial_urn.svg"
                                                alt="Image description for memorial_urn"
                                                class="icon"
                                            />
                                            <span class="amount"> {{ memorialCapacityText }} </span>
                                            <div class="separator"></div>
                                        </div>

                                        <div
                                            class="unspecified-capacity item-with-separator"
                                            v-if="unspecifiedCapacityText"
                                        >
                                            <img
                                                loading="lazy"
                                                src="https://demo.chronicle.rip/assets/images/unspecified_urn.svg"
                                                alt="Image description for unspecified_urn"
                                                class="icon"
                                            />
                                            <span class="amount"> {{ unspecifiedCapacityText }} </span>
                                            <div class="separator"></div>
                                        </div>

                                        <div
                                            class="item-with-separator"
                                            v-if="occupationDirectionCode"
                                        >
                                            <div
                                                class="direction-icon-wrapper"
                                                :title="occupationDirectionName"
                                                data-toggle="tooltip-city"
                                            >
                                                <span class="direction-icon"
                                                    ><i
                                                        class="fas"
                                                        :class="occupationDirectionClass"
                                                    ></i
                                                ></span>
                                                <div>{{ occupationDirectionCode }}</div>
                                            </div>
                                            <div class="separator"></div>
                                        </div>

                                        <div
                                            class="item-with-separator"
                                            v-if="occupationType"
                                        >
                                            <span>{{ occupationType }}</span>
                                            <div class="separator"></div>
                                        </div>

                                        <div
                                            class="item-with-separator"
                                            v-if="occupationPosition"
                                        >
                                            <span>{{ occupationPosition }}</span>
                                            <div class="separator"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="occupation-inscription"
                    v-if="occupationInscription"
                >
                    <div class="content">
                        <span>
                            <!-- <img loading="lazy" alt="Image description for headstone_inscription_icon" src="https://demo.chronicle.rip/assets/images/headstone_inscription_icon.svg"> -->
                            <svg
                                class="icon"
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="14"
                                viewBox="0 0 16 14"
                                fill="none"
                            >
                                <path
                                    d="M1.09961 13H14.8989M3.5782 13H12.4203V5.25C12.4203 5.25 12.1748 1 7.99933 1C3.82381 1 3.5782 5.25 3.5782 5.25V13ZM6.10451 4.78939H9.89398V6.68413H6.10451V4.78939Z"
                                    stroke="currentColor"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </span>
                        <p>{{ occupationInscription }}</p>
                    </div>
                </div>

                <div class="occupation-interments">
                    <component
                        v-bind:is="componentView"
                        v-model="form"
                        :panelCfg="panelCfg"
                        :parentId="parentId"
                        :moduleCode="moduleCode"
                        :additional="additional"
                        :baseTranslateID="baseTranslateID"
                    />
                </div>
            </div>

            <div class="occupation-actions">
                <div class="occupation-actions-wrapper">
                    <button
                        v-for="btn in activeButtons"
                        :key="`occupation-action-${btn.id}`"
                        :class="['btn', btn.class]"
                        :disabled="!btn.active"
                        @click.prevent="btn.fn"
                    >
                        <i
                            class="icon"
                            :class="btn.icon"
                        ></i>
                        <span class="occupation-action-title">{{ $t(btn.name) }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="module">
import CemeteryElementMixin from "../mixins/CemeteryElementMixin";
import { EVENTS } from "../../../shared/config/event-constants";


export default {

    mixins: [CemeteryElementMixin],
    components: {
        OccupationPublic: () => import(/* webpackChunkName: "cemeteries-occupationpublic" */ "./../elements/OccupationPublic"),
        OccupationPrivate: () => import(/* webpackChunkName: "cemeteries-occupationprivate" */ "./../elements/OccupationPrivate"),
        MaterialSlideShow: () => import(/* webpackChunkName: "MaterialSlideShow" */ "src/components/common/MaterialSlideShow")
    },
    props: {
        eventOccupationViewDetail: {
            type: String,
            default: EVENTS.SHOW_MODAL_DETAIL_OCCUPATION
        },
        eventIntermentAdd: {
            type: String,
            default: EVENTS.SHOW_MODAL_DETAIL_INTERMENT
        },
        eventDeedOwnerAdd: {
            type: String,
            default: EVENTS.SHOW_MODAL_DETAIL_DEED_OWNER
        },
        eventDeedOwnerViewDetail: {
            type: String,
            default: EVENTS.SHOW_MODAL_DETAIL_DEED_OWNER
        }
    },
    data() {
        return {
            form: this.value
        };
    },
    mounted() {
        this.init();
    },
    computed: {
        allowAddInterment() {
            return this.actions?.interment?.create;
        },
        allowAddDeedOwner() {
            return this.actions?.deed_owner?.create;
        },
        allowViewDetailDeedOwner() {
            return this.actions?.deed_owner?.detail;
        },
        enableAddInterment() {
            return this.allowAddInterment && ((this.form.total_capacity > 0 && this.form.total_capacity > this.interments.length) || this.form.total_capacity == 0);
        },
        enableAddDeedOwner() {
            return this.allowAddDeedOwner && !this.hasDeedOwners;
        },
        enableViewDetailDeedOwner() {
            return this.allowViewDetailDeedOwner && this.hasDeedOwners;
        },
        buttons() {
            return [
                {
                    id: "add-interment",
                    name: `${this.translateID}.buttons.interment.add`,
                    fn: evt => this.onAddInterment(evt),
                    active: this.enableAddInterment,
                    order: 1,
                    status: this.allowAddInterment,
                    class: ['add-interment', {'primary': !this.enableAddDeedOwner}],
                    icon: 'far fa-user',
                    // icon: '<svg class="icon" xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">\
                    //         <path d="M14.9314 5.16503C15.4855 8.50518 12.6042 11.3999 9.16891 10.9546C7.06339 10.6206 5.40114 8.95053 5.06868 6.8351C4.5146 3.49496 7.39584 0.600078 10.7203 1.04543C12.9367 1.26811 14.7097 3.0496 14.9314 5.16503Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />\
                    //         <path d="M1 19V16.5C1 16.2 1.10588 15.9 1.42353 15.7C2.37647 14.9 5.34118 13 10 13C14.6588 13 17.6235 14.9 18.5765 15.7C18.7882 15.9 19 16.2 19 16.5V19C19 19.6 18.5765 20 17.9412 20H2.05882C1.42353 20 1 19.6 1 19Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />\
                    //     </svg>',
                },
                {
                    id: "add-deed-owner",
                    name: `${this.translateID}.buttons.deed_owner.add`,
                    fn: evt => this.onAddDeedOwner(evt),
                    active: true,
                    order: 1,
                    status: this.enableAddDeedOwner,
                    class: ["add-deed-owner", "primary"],
                    icon: "far fa-rectangle-list"
                },
                {
                    id: "view-deed-owner",
                    name: `${this.translateID}.buttons.deed_owner.view`,
                    fn: (evt) => this.onViewDetailDeedOwner(evt, this.currentDeedOwner),
                    active: true,
                    order: 1,
                    status: this.enableViewDetailDeedOwner,
                    class: ['view-deed-owner'],
                    icon: 'far fa-rectangle-list',
                    // icon: '<svg class="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18" fill="none">\
                    //         <path d="M20.5 16.5H3.5C2.4 16.5 1.5 15.6 1.5 14.5V3.5C1.5 2.4 2.4 1.5 3.5 1.5H20.5C21.6 1.5 22.5 2.4 22.5 3.5V14.5C22.5 15.6 21.6 16.5 20.5 16.5Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />\
                    //         <path d="M17.5 14.5C16.9 14.5 16.5 14.1 16.5 13.5C16.5 12.9 16.9 12.5 17.5 12.5C18.1 12.5 18.5 12.9 18.5 13.5C18.5 14.1 18.1 14.5 17.5 14.5Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />\
                    //         <path d="M4.5 9.5H15.5" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />\
                    //         <path d="M4.5 7.5H19.5" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />\
                    //         <path d="M10.5 4.5H13.5" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />\
                    //         <path d="M4.5 12.5H7.5" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />\
                    //     </svg>',
                }
            ];
        },
        activeButtons() {
            return this.buttons.filter(b => b.status).sort(b => b.order);
        },
        interments() {
            return this.form?.interments ?? [];
        },
        // hasInterments() {
        //     return this.interments.length > 0;
        // },
        deedOwners() {
            return this.form?.deed_owners ?? [];
        },
        hasDeedOwners() {
            return this.deedOwners.length > 0;
        },
        currentDeedOwner() {
            return this.hasDeedOwners ? this.deedOwners[0] : null;
        },
        componentView() {
            // return 'OccupationPublic';
            return "OccupationPrivate";
        },
        occupation() {
            return this.form ?? {};
        },
        occupationCode() {
            return this.occupation?.code;
        },
        occupationName() {
            return this.occupation?.name;
        },
        occupationDirection() {
            return this.occupation.direction ?? {};
        },
        occupationDirectionName() {
            return this.occupationDirection.name;
        },
        occupationDirectionCode() {
            return this.occupationDirection.code ? this.occupationDirection.code.toUpperCase() : null;
        },
        occupationDirectionClass() {
            return this.occupationDirection.css;
        },
        occupationState() {
            return this.occupation?.state;
        },
        occupationType() {
            return this.occupation?.type;
        },
        occupationPosition() {
            return this.occupation?.position;
        },
        occupationInscription() {
            return this.occupation?.inscription;
        },
        occupationImages() {
            let imgs = this.occupation?.images ?? [];
            return imgs.length > 0 ? imgs : [this.defaultImage];
        },
        occupationGeometry() {
            return this.occupation?.geojson;
        },
        cemeteryName() {
            return this.occupation?.cemetery?.name;
        },
        totalCapacityText() {
            return this.formatCapacity({ total: this.occupation?.total_capacity, current: this.occupation?.interments_count }, true);
        },
        burialsCapacityText() {
            return this.formatCapacity(this.occupation?.burials_capacity ?? {});
        },
        cremationCapacityText() {
            return this.formatCapacity(this.occupation?.cremation_capacity ?? {});
        },
        entombmentCapacityText() {
            return this.formatCapacity(this.occupation?.entombment_capacity ?? {});
        },
        memorialCapacityText() {
            return this.formatCapacity(this.occupation?.memorial_capacity ?? {});
        },
        unspecifiedCapacityText() {
            return this.formatCapacity(this.occupation?.unspecified_capacity ?? {});
        }
    },
    methods: {
        init() {
            this.highlightFeature({
                ...{
                    geojson: this.occupationGeometry,
                    zoom: false,
                    layerId: "occupations"
                },
                ...this.params
            });
        },
        reset() {},

        formatCapacity(capacity = {}, force = false) {
            let current = parseInt(capacity.current ?? 0);
            let total = parseInt(capacity.total ?? 0);
            return parseInt(total) > 0 || force ? (current > 0 ? current : "-") + " / " + (total > 0 ? total : "-") : null;
        },
        onViewDetailOccupation(params = {}) {
            if (!this.allowViewDetail) return;

            if (this.eventOccupationViewDetail) {
                this.$eventBus.publish(this.moduleCode, this.eventOccupationViewDetail, { data: { ...this.form } });
            }
        },
        onAddInterment(params = {}) {
            if (!this.enableAddInterment) return;

            if (this.eventIntermentAdd) {
                this.$eventBus.publish(this.moduleCode, this.eventIntermentAdd, {
                    data: {
                        occupation_id: this.form?.id
                    }
                });
            }
        },
        onAddDeedOwner(params = {}) {
            if (!this.enableAddDeedOwner) return;

            if (this.eventDeedOwnerAdd) {
                this.$eventBus.publish(this.moduleCode, this.eventDeedOwnerAdd, {
                    data: {
                        occupation_id: this.form?.id
                    }
                });
            }
        },
        onViewDetailDeedOwner(params = {}, item={}) {
            let id = item?.id ?? null;
            if(!this.enableViewDetailDeedOwner || !id) return;

            if (this.eventDeedOwnerViewDetail) {
                this.$eventBus.publish(this.moduleCode, this.eventDeedOwnerViewDetail, {
                    data: {
                        id,
                        occupation_id: this.form?.id
                    }
                });
            }
        }
    },
    watch: {
        value: {
            deep: true,
            handler: function (value, oldValue) {
                this.form = value;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.occupation-view {
    .occupation-details {
        overflow-x: hidden;

        .text-content {
            margin-bottom: 60px;

            .nav-tabs {
                .nav-item {
                    .nav-link {
                        color: #495057;

                        &.active {
                            color: var(--primary-color);
                        }
                    }
                }
            }

            .occupation-detail-header {
                // display: flex;
                // justify-content: space-between;
                // // flex-direction: column;
                // // row-gap: 8px;
                // padding: 0;

                .cemetery-name {
                    font-size: 14px;
                    // opacity: .6;
                    margin-bottom: 0;
                }

                .occupation-info {
                    .wrapper {
                        // display: flex;
                        // flex-direction: column;

                        .occupation-status-id {
                            display: flex;
                            align-self: center;

                            .occupation-id {
                                font-size: 1.4rem;
                                text-transform: uppercase;
                                letter-spacing: normal;
                                color: #181429;
                                margin-right: 8px;
                                margin-bottom: 0;

                                .main-title {
                                    display: flex;
                                    align-items: center;
                                    gap: 10px;
                                }

                                .occupation-status {
                                    display: inline-block;
                                    padding: 0 4px;
                                    border-radius: 4px;
                                    font-weight: 700;
                                    font-size: 10px;
                                    line-height: 17px;
                                    letter-spacing: 0.5px;
                                    align-items: center;
                                    justify-content: center;
                                    text-transform: uppercase;
                                    height: 16px;
                                    box-sizing: border-box;
                                    vertical-align: middle;

                                    &.forsale,
                                    &.vacant {
                                        background-color: rgba(39, 174, 96, 0.2);
                                        color: #27ae60;
                                    }

                                    &.reserved {
                                        background-color: rgba(242, 201, 76, 0.2);
                                        color: #f2c94c;
                                    }

                                    &.unavailable {
                                        color: rgba(10, 10, 10, 0.6);
                                        border: 1px solid rgba(10, 10, 10, 0.2);
                                    }
                                }
                            }
                        }
                    }

                    .occupation-interments-info {
                        margin-bottom: 16px;
                        color: rgba(24, 20, 41, 0.6);
                        font-size: 14px;

                        .amounts-direction {
                            display: flex;
                            flex-wrap: wrap;

                            .item-with-separator {
                                display: flex;
                                align-self: center;
                                margin-bottom: 4px;
                            }

                            .icon {
                                margin-right: 3px;
                                font-size: 10px;
                                color: #181429;
                            }

                            .amount {
                                line-height: 16px;
                                vertical-align: text-top;
                            }

                            .separator {
                                background: #323233;
                                opacity: 0.6;
                                width: 1px;
                                height: 16px;
                                margin: 0 8px;
                                align-self: center;
                            }

                            .direction-icon-wrapper {
                                display: flex;
                                align-self: center;

                                .direction-icon {
                                    align-self: center;
                                    margin-right: 3px;
                                    font-size: 16px;

                                    .fas.northwest {
                                        transform: rotate(-135deg);
                                    }
                                    .fas.northeast {
                                        transform: rotate(-45deg);
                                    }
                                    .fas.southeast {
                                        transform: rotate(45deg);
                                    }
                                    .fas.southwest {
                                        transform: rotate(135deg);
                                    }
                                }
                            }
                        }
                    }
                }

                .occupation-view-btn {
                    min-width: auto;
                    max-height: 70px;
                    margin: 0 0 10px 10px;
                    padding: 8px 8px;
                    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14), 0 0 0 0 rgba(0, 0, 0, 0.12);
                    // border: 1.5px solid #e5e5e5;
                    border-radius: 10px;
                    line-height: 25px;

                    .view-icon {
                        font-size: 20px;
                    }

                    .text-icon {
                        font-size: 11px;
                        line-height: 14px;
                        // color: #673ab7;
                        text-align: center;
                        text-transform: uppercase;
                        margin-bottom: 0;
                    }
                }
            }

            .occupation-inscription {
                // margin-bottom: 24px;
                .content {
                    font-size: 16px;
                    line-height: 16px;
                    margin-bottom: 0;
                    display: flex;

                    .icon {
                        margin-right: 10px;
                        align-items: baseline;
                    }
                }
            }
        }

        .occupation-actions {
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 56px;
            z-index: 2;

            .occupation-actions-wrapper {
                background-color: #fff;
                display: flex;
                width: 100%;
                height: 100%;

                .btn {
                    width: 100%;
                    border-radius: 0;
                    min-width: auto;
                    margin: 0;
                    padding: 0 16px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 100%;
                    width: 100%;
                    border-radius: 0;
                    box-shadow: 0 5px 16px rgba(0, 0, 0, 0.11), 0 25px 64px rgba(0, 0, 0, 0.13);
                    background-color: #ffffff;
                    color: var(--primary-color);

                    &:hover,
                    &:focus,
                    &:active {
                        outline: 0;
                    }

                    .icon {
                        margin-right: 10px;
                        font-size: 20px;
                    }

                    span:not(.icon) {
                        flex: 0;
                        text-transform: uppercase;
                        line-height: 16px;
                        font-weight: 700;
                        font-size: 0.75rem;
                        font-family: var(--city-font-family);
                    }

                    // &.view-deed-owner {
                    //     color: var(--primary-color);
                    // }

                    &.primary {
                        background-color: var(--primary-color);
                        color: #ffffff;
                    }
                    &.white {
                        background-color: #ffffff;
                        color: var(--primary-color);
                    }

                    &.disabled,
                    &:disabled {
                        color: rgba(0, 0, 0, 0.26);
                        background-color: rgba(0, 0, 0, 0.12);
                    }
                }
            }
        }
    }
}
</style>
